<template>
  <div>
    <div class="card card-primary" style="margin: 20px 0;">
      <div class="card-header pt-3 pb-3" style="background-color: #007bff; color: white;">
        <a data-toggle="collapse" href="#lineas_negocio" aria-expanded="true" id="heading-lineas_negocio"
          class="d-block" style="color: white; text-decoration: none; font-size: 16px; font-weight: bold;">
          <i class="fa fa-chevron-down pull-right"></i>
          <i class="fa fa-briefcase mr-2"></i>
          Líneas de Negocio
        </a>
      </div>
      <div id="lineas_negocio" class="collapse show">
        <div class="card-body" style="padding: 25px;">
          <div class="alert alert-success mb-3">
            <i class="fas fa-check-circle"></i>
            <strong>Información:</strong> Selecciona las líneas de negocio que aplican para este remolque.
          </div>

          <!-- Indicador de carga -->
          <div v-if="cargando" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2 text-muted">Cargando líneas de negocio...</p>
          </div>

          <!-- Lista de líneas de negocio -->
          <div v-else>
            <div v-for="linea in listasForms.lineas" :key="linea.id" style="margin-bottom: 15px;">
              <div class="form-group">
                <div class="
                    custom-control
                    custom-switch
                    custom-switch-off-secundary
                    custom-switch-on-success
                  " style="font-size: 16px;">
                  <input type="checkbox" class="custom-control-input" :id="'linea_' + linea.id"
                    @change="actualizarLinea(linea.id)" v-model="form.linea[linea.id]"
                    :disabled="linea.id === 15" />
                  <label class="custom-control-label" :for="'linea_' + linea.id"
                    style="font-size: 16px; font-weight: 500; padding-left: 5px;">{{ linea.nombre }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "RemolqueLinea",
  props: {
    lineasNegocio: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        linea: {},
      },
      listasForms: {
        lineas: [],
      },
      cargando: false,
    };
  },
  methods: {
    actualizarLinea(lineaId) {
      // OBLIGATORIO: No permitir desmarcar la línea 15
      if (lineaId === 15) {
        this.$set(this.form.linea, 15, true);
        if (this.$parent) {
          this.$parent.lineasSeleccionadas = true;
        }
        return;
      }
      const estaSeleccionada = this.form.linea[lineaId];
      this.cargando = true;
      // Notificar al componente padre sobre el cambio
      this.$emit('linea-cambiada', {
        lineaId: lineaId,
        seleccionada: estaSeleccionada
      });

      // Solo hacer llamada al API si hay un ID de remolque (está editando)
      if (this.$parent.form.id) {
        // Llamar al endpoint para asignar/desasignar línea
        axios({
          method: "PUT",
          url: "/api/argentina/trailers/assingOrRevokeLinea",
          data: {
            remolque_id: this.$parent.form.id,
            linea: lineaId,
            accion: estaSeleccionada, // true para asignar, false para desasignar
          },
        })
          .then(() => {
            this.cargando = false;
            this.$swal({
              icon: "success",
              title: "Línea de Negocio Actualizada",
              text: estaSeleccionada ? "Línea asignada correctamente" : "Línea desasignada correctamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
            });
          })
          .catch((error) => {
            this.cargando = false;
            // Revertir el cambio en caso de error
            this.$set(this.form.linea, lineaId, !estaSeleccionada);
            // Asegurar que la línea 15 siempre esté seleccionada
            if (lineaId === 15) {
              this.$set(this.form.linea, 15, true);
              if (this.$parent) {
                this.$parent.lineasSeleccionadas = true;
              }
            }
            this.$swal({
              icon: "error",
              title: "Error",
              text: "No se pudo actualizar la línea de negocio",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          });
      }
    },

    // Método para obtener las líneas seleccionadas (usado al crear)
    getLineasSeleccionadas() {
      const lineasSeleccionadas = [];
      // OBLIGATORIO: Siempre incluir la línea 15
      lineasSeleccionadas.push(15);
      for (const lineaId in this.form.linea) {
        if (this.form.linea[lineaId] === true && parseInt(lineaId) !== 15) {
          lineasSeleccionadas.push(parseInt(lineaId));
        }
      }
      return lineasSeleccionadas;
    },
    async getLineasRemolque() {
      try {
        this.cargando = true;

        // Preparar las promesas para las consultas
        const promesas = [
          axios.get("/api/admin/lineasNegocios/lista")
        ];
        
        // OBLIGATORIO: Solo cargar la línea 15 para Argentina

        // Solo agregar la segunda consulta si estamos editando
        if (this.$parent.form.id) {
          promesas.push(axios.get("/api/argentina/trailers/getLineas/" + this.$parent.form.id));
        }

        // Ejecutar todas las consultas en paralelo
        const respuestas = await Promise.all(promesas);
        const lineasDisponibles = respuestas[0].data;
        const lineasAsignadas = this.$parent.form.id ? respuestas[1].data : [];

        // OBLIGATORIO: Solo mostrar y cargar la línea 15 para Argentina
        const linea15 = lineasDisponibles.find(linea => linea.id === 15);
        if (linea15) {
          this.listasForms.lineas = [{
            id: linea15.id,
            nombre: linea15.nombre,
            estado: true
          }];
          this.form.linea = {};
          this.$set(this.form.linea, 15, true);
          // Notificar al padre que la línea 15 está seleccionada
          if (this.$parent) {
            this.$parent.lineasSeleccionadas = true;
          }
        } else {
          this.listasForms.lineas = [];
          this.form.linea = {};
        }

      } catch (error) {
        console.error("Error al cargar líneas de negocio:", error);
        // Asegurar que la línea 15 siempre esté disponible incluso si hay error
        const linea15 = { id: 15, nombre: "Línea de Negocio 15", estado: true };
        this.listasForms.lineas = [linea15];
        this.form.linea = {};
        this.$set(this.form.linea, 15, true);
        if (this.$parent) {
          this.$parent.lineasSeleccionadas = true;
        }
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar las líneas de negocio",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        this.cargando = false;
        // Notificar al componente padre que terminó de cargar
        this.$emit('lineas-cargadas');
      }
    },
    actualizarSeleccionDesdeProps() {
      // Actualizar la selección basada en las props recibidas
      this.listasForms.lineas.forEach(linea => {
        const estaSeleccionada = this.lineasNegocio.some(ln =>
          (typeof ln === 'object' ? ln.id : ln) === linea.id
        );
        this.$set(this.form.linea, linea.id, estaSeleccionada);
      });
    },
  },
  mounted() {
    this.getLineasRemolque();
  },
  watch: {
    '$parent.form.id': function (newVal, oldVal) {
      // Si el ID cambia de null a un valor (después de crear), recargar las líneas
      if (oldVal === undefined && newVal) {
        this.getLineasRemolque();
      }
    },
    lineasNegocio: {
      handler(newVal) {
        // Si se actualizan las líneas de negocio desde el padre, actualizar la selección
        if (newVal && newVal.length > 0 && this.listasForms.lineas.length > 0) {
          this.actualizarSeleccionDesdeProps();
        }
      },
      deep: true
    },


  },
};
</script>
